import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { createRecordBasePlansetTemplate, createRecordBasePlansetTemplateFailure, createRecordBasePlansetTemplateSuccess, fetchZaiSinglePlansetRecordData, fetchZaiSinglePlansetRecordDataFailure, fetchZaiSinglePlansetRecordDataSuccess, findPlansetTemplate, findPlansetTemplateFailure, findPlansetTemplateSuccess, findRecordBasePlansetTemplate, findRecordBasePlansetTemplateFailure, findRecordBasePlansetTemplateSuccess, generateElectricalCalcs, generateElectricalCalcsFailure, generateElectricalCalcsSuccess, saveElectricalData, saveElectricalDataFailure, saveElectricalDataSuccess, saveModuleStringing, saveModuleStringingFailure, saveModuleStringingSuccess, updateElectricalCalculationData, updateElectricalCalculationDataFailure, updateElectricalCalculationDataSuccess, savefeedinginformation, savefeedinginformationFailure, savefeedinginformationSuccess } from "./zaiautogenplanset.actions";
import { ZAIautogenPlansetService } from "../../core/services/zaiautogenplanset.service";
import { ToastifyService } from "../../shared/toastify-service";

@Injectable()
export class ZaiautogenPlansetEffects {

    // find template
  findPlansetTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(findPlansetTemplate),
      mergeMap(({postdata}) =>
        this.zaiservice.findTemplate(postdata).pipe(
          map((templatedata) => {
            return findPlansetTemplateSuccess({ templatedata: templatedata });
          }),
          catchError((error) =>
            of(findPlansetTemplateFailure({ error }))
          )
        )
      ),
    ),
  );

   // Fetch Planset Record
   fetchZaiSinglePlansetRecordData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchZaiSinglePlansetRecordData),
      mergeMap(({ recordguid }) =>
        this.zaiservice.getZaiPlansetsRecordData(recordguid).pipe(
          map((plansetrecord) => fetchZaiSinglePlansetRecordDataSuccess({ plansetrecord })),
          catchError((error) => of(fetchZaiSinglePlansetRecordDataFailure({ error })))
        )
      ),
    ),
  );

  // find Record Base template
  findRecordBasePlansetTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(findRecordBasePlansetTemplate),
      mergeMap(({postdata}) =>
        this.zaiservice.findRecordBaseTemplate(postdata).pipe(
          map((templatedata) => {
            return findRecordBasePlansetTemplateSuccess({ templatedata: templatedata });
          }),
          catchError((error) =>
            of(findRecordBasePlansetTemplateFailure({ error }))
          )
        )
      ),
    ),
  );

  // find Record Base template
  createRecordBasePlansetTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createRecordBasePlansetTemplate),
      mergeMap(({postdata}) =>
        this.zaiservice.createRecordBaseTemplate(postdata).pipe(
          map((templatedata) => {
            return createRecordBasePlansetTemplateSuccess();
          }),
          catchError((error) =>
            of(createRecordBasePlansetTemplateFailure({ error }))
          )
        )
      ),
    ),
  );

  createRecordBasePlansetTemplateFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createRecordBasePlansetTemplateFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Module Stringing
  saveModuleStringing$ = createEffect(() =>
    this.actions$.pipe(
      ofType(saveModuleStringing),
      mergeMap(({postdata}) =>
        this.zaiservice.updateModuleStringing(postdata).pipe(
          map((modulestringingobj) => {
            return saveModuleStringingSuccess({ modulestringingobj: modulestringingobj});
          }),
          catchError((error) =>
            of(saveModuleStringingFailure({ error }))
          )
        )
      ),
    ),
  );

  saveModuleStringingSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveModuleStringingSuccess),
        tap((record: any) => {
          this.toastifyService.showSuccessMessage("Records updated successfully.");
        })
      ),
    { dispatch: false }
  );

  saveModuleStringingFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveModuleStringingFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

    // Module Electrical
    saveElectricalData$ = createEffect(() =>
      this.actions$.pipe(
        ofType(saveElectricalData),
        mergeMap(({postdata}) =>
          this.zaiservice.updateElectricalData(postdata).pipe(
            map((electricalobj) => {
              return saveElectricalDataSuccess({ electricaldataobj: electricalobj});
            }),
            catchError((error) =>
              of(saveElectricalDataFailure({ error }))
            )
          )
        ),
      ),
    );
  
    saveElectricalDataFailure$ = createEffect(
      () =>
        this.actions$.pipe(
          ofType(saveElectricalDataFailure),
          tap((error: any) => {
            this.toastifyService.showErrorMessage(error.error.message);
          })
        ),
      { dispatch: false }
    );

     // Generate Electrical Calcs
     generateElectricalCalcs$ = createEffect(() =>
      this.actions$.pipe(
        ofType(generateElectricalCalcs),
        mergeMap(({plansetjobguid}) =>
          this.zaiservice.generateElectricalCalcs(plansetjobguid).pipe(
            map((electricaldata) => {
              return generateElectricalCalcsSuccess({ electricaldata: electricaldata});
            }),
            catchError((error) =>
              of(generateElectricalCalcsFailure({ error }))
            )
          )
        ),
      ),
    );

    generateElectricalCalcsSuccess$ = createEffect(
      () =>
        this.actions$.pipe(
          ofType(generateElectricalCalcsSuccess),
          tap(() => {
            this.toastifyService.showSuccessMessage("Electrical calculation generated succesfully");
          })
        ),
      { dispatch: false }
    );
  
    generateElectricalCalcsFailure$ = createEffect(
      () =>
        this.actions$.pipe(
          ofType(generateElectricalCalcsFailure),
          tap((error: any) => {
            this.toastifyService.showErrorMessage(error.error.message);
          })
        ),
      { dispatch: false }
    );

    // Update Electrical Calcs
    updateElectricalCalculationData$ = createEffect(() =>
      this.actions$.pipe(
        ofType(updateElectricalCalculationData),
        mergeMap(({id, postdata}) =>
          this.zaiservice.updateElectricalCalcs(id, postdata).pipe(
            map((electricaldata) => {
              return updateElectricalCalculationDataSuccess({ electricaldataobj: electricaldata});
            }),
            catchError((error) =>
              of(updateElectricalCalculationDataFailure({ error }))
            )
          )
        ),
      ),
    );

    updateElectricalCalculationDataSuccess$ = createEffect(
      () =>
        this.actions$.pipe(
          ofType(updateElectricalCalculationDataSuccess),
          tap(() => {
            this.toastifyService.showSuccessMessage("Electrical calculation updated succesfully");
          })
        ),
      { dispatch: false }
    );
  
    updateElectricalCalculationDataFailure$ = createEffect(
      () =>
        this.actions$.pipe(
          ofType(updateElectricalCalculationDataFailure),
          tap((error: any) => {
            this.toastifyService.showErrorMessage(error.error.message);
          })
        ),
      { dispatch: false }
    );

    // SAVE FEEDING INFORMATION
    savefeedinginformation$ = createEffect(() =>
      this.actions$.pipe(
        ofType(savefeedinginformation),
        mergeMap(({postdata}) =>
          this.zaiservice.updateFeedingInformation(postdata).pipe(
            map((electricaldata) => {
              return savefeedinginformationSuccess();
            }),
            catchError((error) =>
              of(savefeedinginformationFailure({ error }))
            )
          )
        ),
      ),
    );

    savefeedinginformationSuccess$ = createEffect(
      () =>
        this.actions$.pipe(
          ofType(savefeedinginformationSuccess),
          tap(() => {
            this.toastifyService.showSuccessMessage("Feeding information updated successfully");
          })
        ),
      { dispatch: false }
    );

    savefeedinginformationFailure$ = createEffect(
      () =>
        this.actions$.pipe(
          ofType(savefeedinginformationFailure),
          tap((error: any) => {
            this.toastifyService.showErrorMessage(error.error.message);
          })
        ),
      { dispatch: false }
    );

  constructor(
    private actions$: Actions,
    private zaiservice: ZAIautogenPlansetService,
    private toastifyService: ToastifyService
  ) { }
  
}